import * as React from 'react';
import {Form} from '../reusableComponents/FormComponents/Form';
import {FormFooter} from '../reusableComponents/FormComponents/FormFooter';
import {InputField} from '../reusableComponents/FormComponents/InputField';
import {ImageUpload} from '../reusableComponents/ImageUpload';
import {OrgModel} from '../../model/OrgModel';
import {TextColorBtn} from '../../constants/generals';
import {TextColor} from '../../constants/generals';
import {saveModules} from '../../services/moduleService';
import {getCategoryDetails} from '../../services/moduleService';
import { IMAGEALLOWEDEXE } from 'src/constants/generals';
import {ErrorPage} from '../reusableComponents/ErrorPage';
import {Loader} from '../reusableComponents/Loader/Loader';
import {Async} from '../reusableComponents/Async';
import { RaisedButton } from 'material-ui';
import { getUserData } from 'src/services/utilityServices';
// import {Button} from '../reusableComponents/FormComponents/Button';

export interface ICategoryFormProps {
    model: string;
    id: string;
    // orgImage?: string;
    instance?: OrgModel;
    // loadDefaultValues?: Function;
    Category?: string;
    SubCategory?: string;
    onSubmit: (values) => void;
}

export interface ICategoryFormState {
    isL2User: boolean;
    selectedLevel: string[];
    categoryList: [];
    subCategoryList: string[];
    subCategoryOpt : string[];
    selectedCategory: string[];
    selectedSubCategory: string[];
    selectedSubLevel : string[];
}

export class CategoryFilter extends React.PureComponent<ICategoryFormProps, ICategoryFormState> {
    constructor(props: ICategoryFormProps) {
        super(props);
        this.state = {isL2User: false, selectedLevel: [], categoryList: [], subCategoryList: [], subCategoryOpt: [], selectedCategory: [], selectedSubCategory: [], selectedSubLevel: []};
    }

    public promise = async () => {
        const CategoryArr = await getCategoryDetails();
        this.setState({categoryList: CategoryArr[0]});
        this.setState({subCategoryList: CategoryArr[1]});
        // this.subcategoryOptions(this.props.instance.props.Category);
    }

    public categoryOptions = () => {
        let UserData = getUserData().category;
        let categoryOptions = [];
        let idStr ='';
        categoryOptions.push({label: 'All', value: 'All'});
        if(this.state.categoryList){
            for ( let i = 0; i < this.state.categoryList.length; i++ ) {
                let arr = this.state.categoryList[i];
                if(UserData == arr[0] || UserData === 'all') {
                    idStr = arr[0];
                    idStr = idStr.toString();    
                    categoryOptions.push({label: arr[1], value: arr[1]});
                }
            }
        }
        return categoryOptions;
    }
    public subcategoryOptions = (flag) => { 
        let subcategoryOptions = [];
        let subCategoryOptList = [];
        const selCategoryOptions = this.state.selectedLevel;
        // const selCategoryOptions = flag;
        subCategoryOptList = this.state.subCategoryList; 
        // if (this.props.Category) {
        // }
        // const selCategoryOptions = this.props.Category;
        let usedID = [];
        // usedID = flag;
        usedID = selCategoryOptions;
        if (usedID) {
            this.setState({
                subCategoryOpt: []
            });
            let idStr = '';
            for ( let i = 0; i < usedID.length; i++ ) { // Selected Category ID Array
                let CategoryID = usedID[i];
                for ( let j = 0; j < subCategoryOptList.length; j++ ) {
                    let arr = subCategoryOptList[j];
                    let ObjKeys = Object.keys(subCategoryOptList[j]);
                    if ( ObjKeys == CategoryID ) {
                        let newarr = arr[j + 1];

                        for ( let k = 0; k < newarr.length; k++ ) {
                            let subCatOpt = newarr[k];
                            idStr = subCatOpt[0];
                            idStr = idStr.toString();                
                            subcategoryOptions.push({label: subCatOpt[1], value: idStr});
                        }
                    }
                }
            }
            this.setState({
                subCategoryOpt: subcategoryOptions
            });
        }
        return subcategoryOptions;  
    }

    public onCategoryChange = async (value) => {
        // const labels = this.state.selectedLevel.length > 0 ? this.state.selectedLevel : [];
        if (value) {
            if (value === 'All') {
                value = '';
            }
            await this.setState({
                selectedLevel: value
            });
            const category = this.state.selectedLevel;
            // let newarr = this.subcategoryOptions(category);
        }
    }

    // public getDefaultCategory = (SelectedArr) => {
    //     let idStr = '';
    //     let categoryOptions = [];
    //     if (SelectedArr) {
    //         for ( let i = 0; i <SelectedArr.length; i++ ) {
    //             for ( let j = 0; j < this.state.categoryList.length; j++ ) {
    //                 let arr = this.state.categoryList[j];
    //                 if(SelectedArr[i] == arr[0]){
    //                     idStr = arr[0];
    //                     idStr = idStr.toString(); 
    //                     categoryOptions.push({label: arr[1], value: idStr});
    //                 }
    //             }
    //         }
        
    //     // if (SelectedArr) {
    //         this.setState({
    //             selectedLevel: SelectedArr
    //         });
    //     // }
    //     }
    //     return categoryOptions;
   
    // }

    // public getDefaultSubCategory = (SelectedArr) => {
    //     let subcategoryOptions = [];
    //     let subCategoryOptList = [];
    //     const selCategoryOptions = this.state.selectedLevel;
    //     subCategoryOptList = this.state.subCategoryList; 
    //     let usedID = [];
    //     usedID = selCategoryOptions;
    //     let idStr = '';
    //     if (SelectedArr) {
    //         for ( let i = 0; i < SelectedArr.length; i++ ) { // Selected Category ID Array
    //             let SubCategoryID = SelectedArr[i];
    //             for ( let j = 0; j < subCategoryOptList.length; j++ ) {
    //                 let arr = subCategoryOptList[j];
    //                 let ObjKeys = Object.keys(subCategoryOptList[j]);
    //                 // if ( ObjKeys == CategoryID ) {
    //                     let newarr = arr[j + 1];

    //                     for ( let k = 0; k < newarr.length; k++ ) {
    //                         let subCatOpt = newarr[k];
    //                         if (SubCategoryID == subCatOpt[0]){
    //                             idStr = subCatOpt[0];
    //                             idStr = idStr.toString(); 
    //                             subcategoryOptions.push({label: subCatOpt[1], value: idStr});
    //                         }
    //                     }
    //                 // }
    //             }
    //         }
    //     }
    //     // this.setState({
    //     //     subCategoryOpt: subcategoryOptions
    //     // });
    //     return subcategoryOptions;  
    // }

    onSubmit = (values) => {
        values.Category = this.state.selectedLevel;
        console.log('Value ',this.state.selectedLevel);
        // this.props.Category(this.state.selectedLevel);
        this.props.onSubmit(values);
    }

    public renderContent = () => {
        // const {instance} = this.props;
        const submitStyle: React.CSSProperties = {
            backgroundColor: TextColor
        };    
        return <div className='outerDiv'><Form
                // loadDefaultValues={this.props.loadDefaultValues}
                model={this.props.model}
                onSubmit={this.onSubmit}
                className="user-form category-form"
                 >
                <div className='innerDiv'>
                <InputField
                    id="Category"
                    hintText=""
                    color={'white'}
                    label="Category:"
                    // required
                    type="select"
                    model=".Category"
                    noChips={true}
                    // multi
                    onChange={this.onCategoryChange}
                    menuItems={this.categoryOptions()}
                    defaultValue={'All'}
                />
                {/* <InputField
                    id="SubCategory"
                    hintText=""
                    color={'white'}
                    label="Sub Category:"
                    required
                    type="selectById"
                    model=".SubCategory"
                    noChips={true}
                    multi
                    menuItems={this.state.subCategoryOpt ? this.state.subCategoryOpt : this.subcategoryOptions(0)}
                    defaultValue={instance && this.getDefaultSubCategory(instance.props.SubCategory)}

                    // defaultValue={instance && instance.props.SubCategory}
                /> */}
                {/* <FormFooter submitLabel={'Create'}/> */}
                <RaisedButton
                    type="submit"
                    style={{
                        backgroundColor: TextColor,
                        // color: TextColorBtn
                    }}
                    // style={submitStyle}
                    // className="submit-button"
                    className="submit-button raised-btn  btn-placement"
                    label="Submit"
                    primary={true}
                />
                </div>
                {/* <FormFooter submitLabel={'Create'}/> */}
            </Form>
            </div>;
        }
    public render() {
           return  <Async
            identifier="ModuleUpdateForm"
            promise={this.promise}
            content={this.renderContent()}
            loader={<Loader type="async"/>}
            error={<ErrorPage/>}
        />;
    }
}
// Org Form 11/16/2022  07:00 PM    Chip


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Modules/CategoryFilter.tsx